let SubscriptionState = /*#__PURE__*/function (SubscriptionState) {
  SubscriptionState["ACTIVE"] = "active";
  SubscriptionState["CANCELED"] = "canceled";
  SubscriptionState["EXPIRED"] = "expired";
  SubscriptionState["FAILED"] = "failed";
  SubscriptionState["FUTURE"] = "future";
  SubscriptionState["PAUSED"] = "paused";
  return SubscriptionState;
}({});
let IntervalUnitType = /*#__PURE__*/function (IntervalUnitType) {
  IntervalUnitType["MONTHS"] = "MONTHS";
  IntervalUnitType["WEEKS"] = "WEEKS";
  IntervalUnitType["DAYS"] = "DAYS";
  return IntervalUnitType;
}({});
let PricingTypeType = /*#__PURE__*/function (PricingTypeType) {
  PricingTypeType["RAMP"] = "RAMP";
  PricingTypeType["FIXED"] = "FIXED";
  return PricingTypeType;
}({});
let SubscriptionPaymentMethod = /*#__PURE__*/function (SubscriptionPaymentMethod) {
  SubscriptionPaymentMethod["CREDITCARD"] = "CREDITCARD";
  SubscriptionPaymentMethod["PAYPAL"] = "PAYPAL";
  return SubscriptionPaymentMethod;
}({});

export { IntervalUnitType, PricingTypeType, SubscriptionPaymentMethod, SubscriptionState };
//# sourceMappingURL=Subscriptions.js.map
